import { Paper } from '@mui/material';
import { styled } from '@mui/system';

export const CommonChatWrapper = styled(Paper)(({ theme }) => ({
	display: 'flex',
	overflow: 'hidden',
	height: '100%',
	margin: '0 24px',
	padding: '24px',
	borderRadius: '30px',
	gap: '16px',

	[theme.breakpoints.down(960)]: {
		display: 'block',
		margin: '0',
		padding: '8px',
		borderRadius: '0',
		background: 'none',
		boxShadow: 'none',
	},
}));
